import React, { useState, useEffect } from 'react'
import NomineeDeleteDetails from './NomineeDeleteDetails';
import axios from 'axios';

function NomineeDeleteInt() {

    const [selectedRemarks, setSelectedRemarks] = useState("");
    const [remarks, setRemarks] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [selectedDistCode, setSelectedDistCode] = useState("");
    const [renderContent, setRenderContent] = useState(false);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_URL}/api/DeleteNominee/remarks`)
            .then((response) => {
                setRemarks(response.data);
            })
            .catch((error) => {
                console.error("Error fetching nominee delete:", error);
            });
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_URL}/api/ob/districts`)
            .then((response) => {
                setDistricts(response.data);
            })
            .catch((error) => {
                console.error("Error fetching nominee delete:", error);
            });
    }, []);

    const handleSubmit = () => {
        if (selectedDistCode) {
            setRenderContent(true);

        } else {
            alert("Please select District and Remarks");
        }
    }

    return (
        <div>
            <table align="center" width="50%" >
                <thead>
                    <tr className="tableheader" >
                        <th colSpan={4}> Nominee Delete </th>
                    </tr>
                </thead>
                < tbody >
                    <tr>
                        <td>District </td>
                        {/* < td > <GetDistrictsRoleBased onChange={setSelectedDistCode} value={selectedDistCode} /> </td> */}
                        <td>
                            <select value={selectedDistCode} onChange={(e) => { setSelectedDistCode(e.target.value); setRenderContent(false); }}>
                                <option value="">Select District</option>
                                {
                                    districts.map((district) => (
                                        <option key={district.dist_code} value={district.dist_code}>
                                            {district.dist_name_en}
                                        </option>
                                    ))
                                }
                            </select>
                        </td>
                        < td > Remarks </td>
                        < td >
                            <select value={selectedRemarks} onChange={(e) => { setSelectedRemarks(e.target.value); setRenderContent(false); }
                            }>
                                <option value="" > Select Remarks </option>
                                {
                                    remarks.map((remark) => (
                                        <option key={remark.remark} value={remark.remark} > {remark.remark} </option>
                                    ))
                                }
                            </select>
                        </td>
                    </tr>
                </tbody>
                < tfoot >
                    <tr>
                        <td colSpan={4} align="center" >
                            <button className="button button2" onClick={handleSubmit} >
                                Submit
                            </button>&nbsp;
                            <button className="button button2" onClick={() => window.history.back()}>
                                Back
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
            < br />
            {renderContent && (
                <NomineeDeleteDetails selectedDistCode={selectedDistCode} selectedRemarks={selectedRemarks} />
            )}
        </div>
    );
}

export default NomineeDeleteInt;